export * from './entity-detail-divider.component';
